export default function($urlRouterProvider, $locationProvider) {
    "ngInject";
    $urlRouterProvider.otherwise('/s/');
    $locationProvider.html5Mode(true);
};



// WEBPACK FOOTER //
// ./app/core/config.js